/** Branche dev-preprod : vitrine branchée sur l'API Pré-prod. */
export const currentEnv: string = "prod";

const env: string = currentEnv;

export const Env = env;

const API_LOCAL_URL = "http://localhost:8000";
const API_DEV_URL = "https://api.dev.easymarket.sn";
const API_DEMO_URL = "https://api.dev.easymarket.sn";
const API_PROD_URL = "https://api.dev.easymarket.sn";

/** Clé API du vendeur local (Cheikh Shop / id=4, Bictorys test). */
const VENDEUR_APIKEY_LOCAL =
  "5ce65db6ff7ae13c0f517432a3b186f25217a69c2e429561f0e416d5f6e0b8b6";
const VENDEUR_APIKEY_DEMO =
  "342c1540541dd145f83f5a42e9f02b4414ca235eaf0c4db5270f23c5f1ecb273";
const VENDEUR_APIKEY_PROD =
  "342c1540541dd145f83f5a42e9f02b4414ca235eaf0c4db5270f23c5f1ecb273";

export const APP_URL_LOCAL = "http://localhost:3000/";
export const APP_URL_DEV = "https://preprod.dev.easymarket.sn/";
export const APP_URL_DEMO = "https://preprod.dev.easymarket.sn/";
export const APP_URL_PROD = "https://preprod.dev.easymarket.sn/";

function processApiUrl() {
  if (env === "local") return API_LOCAL_URL;
  if (env === "prod") return API_PROD_URL;
  if (env === "demo") return API_DEMO_URL;
  return API_DEV_URL;
}

function processAppUrl() {
  if (env === "local") return APP_URL_LOCAL;
  if (env === "prod") return APP_URL_PROD;
  if (env === "demo") return APP_URL_DEMO;
  return APP_URL_DEV;
}

function processApikey() {
  if (env === "local") return VENDEUR_APIKEY_LOCAL;
  if (env === "prod") return VENDEUR_APIKEY_PROD;
  if (env === "demo") return VENDEUR_APIKEY_DEMO;
  return VENDEUR_APIKEY_DEMO;
}

export const ApiBaseUrl = processApiUrl();
export const AppBaseUrl = processAppUrl();

export const VendeurApikey = processApikey();

export const GoogleApikey = "AIzaSyChXWZKmUgaWFvIV2WnTVoR2lY3-uhReBg";

export const IntechApikey = "554ACA96-F050-442D-8E29-BEE77FAE821A";

export const GoogleClientId =
  "701177325323-33rje48k1alj39qmb9vspat9urmmrojn.apps.googleusercontent.com";
